import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';

import {vendorCodes} from 'modules/store/vendors';

import {invalidateSecurityCredentials} from 'modules/store/securityCredentials';
import {TIMEOUT_STORE} from 'util/constants';

const
    transformEntitiesFn = credential => {
        if (typeof credential !== 'object') {
            throw new Error('transformEntitiesFn needs an object to transform');
        }

        return {
            id:     credential.id,
            alias:  credential.alias,
            vendor: {
                selected: vendorCodes.alicloud,
                values:   {
                    service: credential.service.id,
                    account: credential.account.id,
                    secret:  credential.secret_key,
                    access:  credential.access_key,
                    slug:    credential.service.slug
                }
            }
        };
    },
    mapFields = {
        secret_key: 'secret',
        access_key: 'access',
        account:    'account'
    },
    mapParametersToSave = {
        secret:  'secret_key',
        access:  'access_key',
        account: 'account',
        service: 'service'
    },
    transformEntitiesToSaveFn = credential => Object.keys(credential.vendor)
        .reduce((ret, key) => ({
            ...ret,
            [mapParametersToSave[key]]: credential.vendor[key]
        }), {
            alias: credential.alias
        });

const exports = storeModuleFactory({
    name:             'alicloudCredentials',
    endpoint:         endpoints.securityCredentials.alicloud.endpoint,
    instanceEndpoint: endpoints.securityCredentials.alicloud.instanceEndpoint,
    callbackActions:  [{
        method: 'create',
        action: invalidateSecurityCredentials
    },{
        method: 'update',
        action: invalidateSecurityCredentials
    },{
        method: 'delete',
        action: invalidateSecurityCredentials
    }],
    timeout: TIMEOUT_STORE.TIMEOUT_STORE_MEDIUM,
    transformEntitiesFn,
    transformEntitiesToSaveFn
});

exports.transformEntitiesFn = transformEntitiesFn;
exports.transformEntitiesToSaveFn = transformEntitiesToSaveFn;
exports.mapFields = mapFields;

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/alicloudCredentials.js